import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import WrapperPage from "../../components/WrapperPage";
import Ellipses from "../../components/Ellipses";
import BaseButton from "../../components/BaseButton";
import StaticCardActionBtn from "../../components/StaticCardActionBtn";
import ExitModal from "../../modals/ExitModal";
import { useTranslation } from "react-i18next";
import useBrowserStorage from "../../hooks/useBrowserStorage";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../utils/routes.js";
import "./style.scss";
import useCurrentGame from "../../hooks/useCurrentGame";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import Game from "../../store/Game";
import useAuth from "../../hooks/useAuth";
import PersonalAccount from "../../store/PersonalAccount";

const MeetPage = observer(() => {
  const { t } = useTranslation();
  const { getItem, setItem } = useBrowserStorage();
  const navigate = useNavigate();
  const location = useLocation();
  const { navigateTo } = useCustomNavigate();
  const { getCurrentGame } = useCurrentGame();
  const { token } = useAuth();

  const navigateByGame = async () => {
    const game = getCurrentGame();
    const matches = Game.countPartnerGameMatches(game.id);
    await PersonalAccount.addGameIdsByMeets(game.id);
    if (matches) {
      navigateTo(ROUTES.MATCHES_PAGE, {
        state: {
          from:
            location.state && location.state.from
              ? location.state.from
              : location.pathname,
        },
      });
    } else {
      navigateTo(ROUTES.IN_GAME_PAGE, {
        state: {
          from:
            location.state && location.state.from
              ? location.state.from
              : location.pathname,
        },
      });
    }
  };

  useEffect(() => {
    const isMeetPageVisited = getItem("isMeetPageVisited");
    if (!isMeetPageVisited) {
      setItem("isMeetPageVisited", true);
    }
  }, []);

  useEffect(() => {
    if (!PersonalAccount.user.id) return;
    const game = getCurrentGame();
    if (game?.id) {
      PersonalAccount.addGameIdsByMeets(game.id);
    }
  }, [PersonalAccount.user.id]);

  return (
    <div className="meet-wrapper centering-page">
      <Ellipses countEllipses={1} className="meet-wrapper-ellipses" />
      <ExitModal />
      <WrapperPage
        headerTitle={t("meet_page.title")}
        backBtn
        burgerMenu={!!token}
        loginBtn={!token}
      >
        <div className="meet-wrapper__description">
          <p className="">{t("meet_page.description.desc1")}</p>
          <br />
          <p className="">{t("meet_page.description.desc2")}</p>
          <br />
          <p>{t("meet_page.description.desc3")}</p>
        </div>
        <div className="meet-wrapper__answers">
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="positive" />
            <p className="meet-wrapper__answer__text">
              {t("meet_page.answers.desc1")}
            </p>
          </div>
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="neutral" />
            <p className="meet-wrapper__answer__text">
              {t("meet_page.answers.desc2")}
            </p>
          </div>
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="negative" />
            <p className="meet-wrapper__answer__text">
              {t("meet_page.answers.desc3")}
            </p>
          </div>
        </div>
        <div className="meet-wrapper__answers-mobile">
          <div className="meet-wrapper__answers-mobile-top">
            <div className="meet-wrapper__answer">
              <StaticCardActionBtn type="positive" />
              <p className="meet-wrapper__answer__text">
                {t("meet_page.answers.desc1")}
              </p>
            </div>
            <div className="meet-wrapper__answer">
              <StaticCardActionBtn type="negative" />
              <p className="meet-wrapper__answer__text">
                {t("meet_page.answers.desc3")}
              </p>
            </div>
          </div>
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="neutral" />
            <p className="meet-wrapper__answer__text">
              {t("meet_page.answers.desc2")}
            </p>
          </div>
        </div>
        <BaseButton
          onClick={() => navigateByGame()}
          className="meet-wrapper__btn-go"
        >
          {t("go")}
        </BaseButton>
      </WrapperPage>
    </div>
  );
});

export default MeetPage;
